import { IStyleAPIData, IStylingFormFields, PredefinedColors } from '../types';

const getPredefinedColorStatuses = (selectedColor?: string) => {
    const colorSet = {
        Blue: {
            isSelected: false
        },
        Red: {
            isSelected: false
        },
        Green: {
            isSelected: false
        },
        Orange: {
            isSelected: false
        }
    };
    let previewImage = '';

    switch (selectedColor) {
        case PredefinedColors.Blue:
            colorSet.Blue.isSelected = true;
            previewImage = 'Blue';
            break;
        case PredefinedColors.Green:
            colorSet.Green.isSelected = true;
            previewImage = 'Green';
            break;
        case PredefinedColors.Orange:
            colorSet.Orange.isSelected = true;
            previewImage = 'Orange';
            break;
        case PredefinedColors.Red:
            colorSet.Red.isSelected = true;
            previewImage = 'Red';
            break;
        default:
            colorSet.Blue.isSelected = true;
    }
    return { colorSet, previewImage };
};

export type StylingResponseType = ReturnType<typeof getStylingJSON>;

export const getStylingJSON = (formData: IStylingFormFields) => {
    const { appStyles, customColor, predefinedColor } = formData;
    const { colorSet, previewImage: predefinedPreviewImageValue } = getPredefinedColorStatuses(predefinedColor.color);
    const effectivePreviewImage = appStyles === 'customColor' ? 'Custom' : predefinedPreviewImageValue;
    return {
        ...colorSet,
        Custom: {
            isSelected: appStyles === 'customColor'
        },
        previewImage: effectivePreviewImage,
        menuColorCode: appStyles === 'customColor' ? customColor.menuColor : predefinedColor.color
        // buttonColorCode: appStyles === 'customColor' ? customColor.buttonColor : predefinedColor.color
    };
};

export const getDefaultStylingFormValues = (apiDefaultValues: IStyleAPIData): IStylingFormFields => {
    const { Custom: custom, buttonColorCode, menuColorCode, Blue: blue, Green: green, Orange: orange, Red: red } = apiDefaultValues;

    let predefinedColorValue;

    if(blue?.isSelected) {
        predefinedColorValue = PredefinedColors.Blue;
    } else if (green?.isSelected) {
        predefinedColorValue = PredefinedColors.Green;
    } else if (orange?.isSelected) {
        predefinedColorValue = PredefinedColors.Orange;
    } else if (red?.isSelected) {
        predefinedColorValue = PredefinedColors.Red;
    } else {
        predefinedColorValue = PredefinedColors.Purple;
    }

    return {
        appStyles: custom?.isSelected ? 'customColor' : 'predefinedColor',
        customColor: {
            buttonColor: buttonColorCode,
            menuColor: menuColorCode
        },
        predefinedColor: {
            color: predefinedColorValue
        }
    };
};
